// @flow

import {
  getLogisticPromotionsApi,
  savePromotionApi,
  updatePromotionApi,
  deletePromotionApi,
} from './api';
import {ofType, ActionsObservable} from 'redux-observable';
import {map, switchMap} from 'rxjs/operators';
import {
  ActionCreator,
  createReducer,
  buildCatchError,
} from '../../../../store/utils';

import type {Action} from '../../../../store/utils';
import type {
  PromotionRequest,
  EditPromotionRequest,
  Promotion,
  PromotionMethod,
} from '../../../../entities';

export type PromotionConfigAction = Action & {
  error?: string,
  promotionRequest?: PromotionRequest,
  promotionEditRequest?: EditPromotionRequest,
  adminRateId?: string,
};

export type PromotionConfigState = {
  promotionMethod?: PromotionMethod,

  isFetchingPromotionMethods?: boolean,
  fetchingPromotionSuccess?: boolean,
  fetchingPromotionError?: boolean,

  isSaving?: boolean,
  savingPromotionSuccess?: boolean,
  savingPromotionError?: boolean,

  messageError?: string,
  promotion?: Promotion,
};

export const initialState: PromotionConfigState = {};

export class SaveShippingPromotion extends ActionCreator<PromotionConfigAction> {}
export class SaveShippingPromotionSuccess extends ActionCreator<PromotionConfigAction> {}
export class SaveShippingPromotionError extends ActionCreator<PromotionConfigAction> {}

export class FetchShippingPromotion extends ActionCreator<PromotionConfigAction> {}
export class FetchShippingPromotionSuccess extends ActionCreator<PromotionConfigAction> {}
export class FetchShippingPromotionError extends ActionCreator<PromotionConfigAction> {}

export class EditShippingPromotion extends ActionCreator<PromotionConfigAction> {}
export class EditShippingPromotionSuccess extends ActionCreator<PromotionConfigAction> {}
export class EditShippingPromotionError extends ActionCreator<PromotionConfigAction> {}

export class DeleteShippingPromotion extends ActionCreator<PromotionConfigAction> {}
export class DeleteShippingPromotionSuccess extends ActionCreator<PromotionConfigAction> {}
export class DeleteShippingPromotionError extends ActionCreator<PromotionConfigAction> {}

export class ResetState extends ActionCreator<PromotionConfigAction> {}

export const actions = {
  savePromotion: (payload: PromotionConfigAction) =>
    new SaveShippingPromotion(payload),
  fetchPromotion: (payload: PromotionConfigAction) =>
    new FetchShippingPromotion(payload),
  editPromotion: (payload: PromotionConfigAction) =>
    new EditShippingPromotion(payload),
  deletePromotion: (payload: PromotionConfigAction) =>
    new DeleteShippingPromotion(payload),
  resetState: () => new ResetState(),
};

export default createReducer<PromotionConfigState>(initialState, {
  [SaveShippingPromotion.type]: (state: PromotionConfigState) => ({
    ...state,
    isSaving: true,
    savingPromotionSuccess: false,
    savingPromotionError: false,
  }),
  [SaveShippingPromotionSuccess.type]: (state: PromotionConfigState) => ({
    ...state,
    isSaving: false,
    savingPromotionSuccess: true,
    savingPromotionError: false,
  }),
  [SaveShippingPromotionError.type]: (
    state: PromotionConfigState,
    {error}
  ) => ({
    ...state,
    isSaving: false,
    savingPromotionSuccess: false,
    savingPromotionError: true,
    messageError: error,
  }),
  [FetchShippingPromotion.type]: (state: PromotionConfigState) => ({
    ...state,
    isFetchingPromotion: true,
    fetchingPromotionSuccess: false,
    fetchingPromotionError: false,
  }),
  [FetchShippingPromotionSuccess.type]: (
    state: PromotionConfigState,
    action: PromotionConfigAction
  ) => {
    const {
      enabled,
      internationalShippingPromotion,
      nationalShippingPromotion,
    } = action.promotionMethod;

    const promotionMethod = {
      enabled,
      internationalShippingPromotion,
      nationalShippingPromotion,
    };
    return {
      ...state,
      isFetchingPromotion: false,
      fetchingPromotionSuccess: true,
      fetchingPromotionError: false,
      promotionMethod: promotionMethod,
    };
  },
  [FetchShippingPromotionError.type]: (
    state: PromotionConfigState,
    {error}
  ) => ({
    ...state,
    isFetchingPromotion: false,
    fetchingPromotionSuccess: false,
    fetchingPromotionError: true,
    messageError: error,
  }),
  [EditShippingPromotion.type]: (state: PromotionConfigState) => ({
    ...state,
    isSaving: true,
    savingPromotionSuccess: false,
    savingPromotionError: false,
  }),
  [EditShippingPromotionSuccess.type]: (state: PromotionConfigState) => ({
    ...state,
    isSaving: false,
    savingPromotionSuccess: true,
    savingPromotionError: false,
  }),
  [EditShippingPromotionError.type]: (
    state: PromotionConfigState,
    action: PromotionConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savcingPromotionSuccess: false,
    savingPromotionError: true,
  }),
  [DeleteShippingPromotion.type]: (state: PromotionConfigState) => ({
    ...state,
    isSaving: true,
    savingPromotionSuccess: false,
    savingPromotionError: false,
  }),
  [DeleteShippingPromotionSuccess.type]: (state: PromotionConfigState) => ({
    ...state,
    isSaving: false,
    savingPromotionSuccess: true,
    savingPromotionError: false,
  }),
  [DeleteShippingPromotionError.type]: (
    state: PromotionConfigState,
    {error}
  ) => ({
    ...state,
    isSaving: false,
    savingPromotionError: true,
    messageError: error,
  }),
  [ResetState.type]: (state: PromotionConfigState) => {
    return {
      ...state,
      isSaving: false,
      isFetchingPromotion: false,
      fetchingPromotionSuccess: false,
      fetchingPromotionError: false,
      savingPromotionSuccess: false,
      savingPromotionError: false,
      messageError: '',
    };
  },
});

export function getLogisticPromotionEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(
      FetchShippingPromotion.type,
      SaveShippingPromotionSuccess.type,
      EditShippingPromotionSuccess.type,
      DeleteShippingPromotionSuccess.type
    ),
    switchMap(() => {
      return getLogisticPromotionsApi().pipe(
        map(
          promotionMethod =>
            new FetchShippingPromotionSuccess({promotionMethod})
        ),
        buildCatchError(FetchShippingPromotionError)
      );
    })
  );
}

export function saveLogisticPromotionEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveShippingPromotion.type),
    switchMap(({promotionRequest}) => {
      return savePromotionApi(promotionRequest).pipe(
        map(() => new SaveShippingPromotionSuccess()),
        buildCatchError(SaveShippingPromotionError)
      );
    })
  );
}

export function editLogisticPromotionEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(EditShippingPromotion.type),
    switchMap(({promotionRequest}) =>
      updatePromotionApi(promotionRequest).pipe(
        map(() => new EditShippingPromotionSuccess()),
        buildCatchError(EditShippingPromotionError)
      )
    )
  );
}

export function deleteLogisticPromotionEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(DeleteShippingPromotion.type),
    switchMap(({promotionRequest}) =>
      deletePromotionApi(promotionRequest).pipe(
        map(() => new DeleteShippingPromotionSuccess()),
        buildCatchError(DeleteShippingPromotionError)
      )
    )
  );
}
